<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { axiosGetPost } from '@router/axiosGetPost'
import Multiselect from 'vue-multiselect'
import HideColumnsTable from '@components/datatablegn/HideColumnsTable'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import 'vue2-datepicker/index.css'
import XLSX from 'xlsx'

export default {
  page: {
    title: 'Accounts Local Expenses',
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Multiselect,
    HideColumnsTable,
  },
  data() {
    return {
      title: 'Accounts Local Expenses',
      items: [
        { text: 'Barracuda', href: '/' },
        { text: 'Local Charges', href: '/localcharges', active: true },
        { text: 'Accounts', href: '/accounts', active: true },
      ],
      tableData: [],
      equipments: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: '',
      filterOn: [],
      sortBy: 'id',
      sortDesc: true,
      fields: [],
      fieldList: [
        { key: 'id', label: 'Id', sortable: true, checkBox: true },
        {
          key: 'request_id',
          label: 'Request_id',
          sortable: true,
          checkBox: true,
        },
        { key: 'name', label: 'Name', sortable: true, checkBox: true },
        { key: 'date', label: 'Date', sortable: true, checkBox: true },
        { key: 'status', label: 'Status', sortable: true, checkBox: true },
        { key: 'options', label: 'Options', sortable: false, checkBox: true },
      ],
      excludeFields: [],
      typeTable: 'LocalChargesAccountsListFCL',
      modalComponent: '',
      modalTitle: '',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
      dateRange: null,
    }
  },
  watch: {
    filter(newValue) {
      localStorage.setItem('searchAccountGlobalChargeListFcl', newValue)
    },
  },
  computed: {
    rows() {
      return this.tableData.length
    },
    computedFilter: function () {
      if (this.filter === null) {
        return null
      }
      console.log('computedFilter', this.filter)
      return [this.filter]
    },
  },
  created() {
    this.dateRangedef()
    this.getSelects()
    this.getData()
    this.interval = setInterval(() => this.increment(), 1000)
  },
  mounted() {
    // Set the initial number of items
    const searchValue = localStorage.getItem('searchAccountGlobalChargeListFcl')
    if (searchValue) {
      this.filter = searchValue
    }
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    formatDate(date) {
      let adjustedDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      )
      return adjustedDate.toISOString().split('T')[0]
    },
    getData() {
      this.loadingTable = true
      axiosGetPost('post', 'localCharges/getAccounts', {
        date: [
          this.formatDate(this.dateRange[0]),
          this.formatDate(this.dateRange[1]),
        ],
      }).then((response) => {
        let data = response
        if (data.success) {
          this.tableData = response.data
          this.loadingTable = false
        } else {
          this.$toastr.e('Error')
        }
        return data
      })
    },

    getSelects() {
      this.loadingTable = true
      axiosGetPost(
        'get',
        'localCharges/getTemplate',
        {},
        'Get data select Accounts LocalCharge FCL'
      ).then((response) => {
        let data = response
        if (data.success) {
          this.equipments = data.data
        } else {
          this.$toastr.e('Error')
        }
        return data
      })
    },
    dateRangedef() {
      let d = moment().subtract(3, 'months')
      let d2 = moment()
      this.dateRange = [
        new Date(d.year(), d.month(), d.format('DD')),
        new Date(d2.year(), d2.month(), d2.format('DD')),
      ]
    },
    restore() {
      this.dateRangedef()
      this.getData()
    },
    findIndex(id) {
      var valObj = this.tableData.findIndex(function (elem) {
        if (elem.id === id) return elem
      })
      return valObj
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    customFilterTable(row, filter) {
      console.log('row', row, '\n filter', filter)
      const baseFilter = filter.trim()
      let rowVar = { ...row }
      let valuesRow = Object.values(rowVar)
      let filtersSp = baseFilter.split(' ')
      const filtersFined = []

      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          let valRowLC = String(valRow).toLowerCase()
          console.log('valRowLC', valRowLC, '\n filterVal', filterVal)
          let filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })
      return filtersFined.length === filtersSp.length
    },
    updateTableFieldsEmit(fields) {
      this.fields = fields
    },
    increment() {
      this.time = this.time + 1
      if (this.time === this.reloadTime) {
        this.time = 0
        this.getData()
      }
    },
    downloadFile(id) {
      axiosGetPost(
        'get',
        '/localCharges/downloadF/' + id,
        {},
        'Download File Operation Localcharge Import'
      ).then((response) => {
        console.log(response)
        if (response.success === true) {
          var link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = response.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              response.status +
              ' Error: ' +
              response.error
          )
        }
        return response
      })
    },
    downloadTemplate(equipment) {
      axiosGetPost(
        'post',
        '/localCharges/getTemplate',
        { equipment: equipment },
        'Download File Template Localcharge Import'
      ).then((response) => {
        console.log(response)
        let data = response.data
        var wb = XLSX.utils.book_new() // make Workbook of Excel
        var wscols = [{ wch: 25 }, { wch: 25 }, { wch: 10 }, { wch: 20 }]
        for (let i = 0; i <= Object.keys(data.table[0]).length - 4; i++) {
          // console.log(i,(data.number_cnt+3),i)
          if (i < data.number_cnt) {
            wscols.push({ wch: 7 })
          } else {
            wscols.push({ wch: 14 })
          }
        }
        var dataXLSX = XLSX.utils.json_to_sheet(data.table)
        dataXLSX['!cols'] = wscols
        XLSX.utils.book_append_sheet(wb, dataXLSX, 'Hoja1') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, data.name) // name of the file is 'book.xlsx'
        return response
        return response
      })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-3 col-md-8 text-md-left">
                <h4 class="header-title mt-0 mb-1"
                  >Accounts LocalCharge List</h4
                >
              </div>
              <div class="col-sm-3 col-md-4 text-md-left">
                <p class="text-muted font-13 mb-4"> </p>
              </div>
            </div>
            <div class="row mb-md-2">
              <div class="col-sm-8 col-md-12 text-md-left">
                <date-picker
                  v-model="dateRange"
                  class="col-5"
                  type="date"
                  range
                  placeholder="Select date range"
                  @change="getData"
                >
                </date-picker>
                <b-button
                  class="btn btn-primary col-md-1"
                  variant="primary"
                  @click="getData"
                  >Update</b-button
                >&nbsp;
                <b-button
                  class="btn btn-primary col-md-1"
                  variant="primary"
                  @click.prevent="restore"
                  >Restore</b-button
                >
                &nbsp;

                <router-link
                  class="btn btn-primary col-md-2 float-right"
                  title="Add Surcharge"
                  href="#"
                  :to="{
                    name: 'localcharges_import',
                    params: { module: 'fcl' },
                  }"
                >
                  Importation&nbsp;
                  <i class="uil uil-cloud-upload"></i>
                </router-link>
                <b-dropdown
                  variant="success"
                  dropleft
                  class="ml-1 col-md-1 float-right"
                >
                  <template slot="button-content">
                    <i class="uil uil-angle-double-left"></i>
                    <i>Template</i>
                  </template>
                  <b-dropdown-item
                    href="#"
                    v-for="row in equipments"
                    :key="row.id"
                    @click="downloadTemplate(row)"
                  >
                    <span v-bind:style="{ color: row.data.color }">
                      <i class="uil uil-file-check-alt"></i>
                      &nbsp; &nbsp; {{ row.name }}
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex mb-md-2">
                <div class="mr-auto">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
                <div>
                  <HideColumnsTable
                    :field-list-fth="fieldList"
                    :type-table="typeTable"
                    @updateTableFieldsEmit="updateTableFieldsEmit"
                  />
                </div>
                <!-- Search -->
                <div>
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
                <!-- End search -->
              </div>
              <div class="table-responsive mb-0 table-responsive-list-menu">
                <b-table
                  striped
                  hover
                  :items="tableData"
                  :fields="fields"
                  :busy="loadingTable"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :filter-function="customFilterTable"
                  @filtered="onFiltered"
                >
                  <template v-slot:table-busy>
                    <div
                      class="row align-items-center justify-content-center"
                      style="height: 150px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <b-spinner
                          label="Loading..."
                          variant="primary"
                          class="ml-3"
                        ></b-spinner>
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(options)="row">
                    <b-dropdown variant="success" dropleft class="ml-1 btn-sm">
                      <template slot="button-content">
                        <i class="uil uil-angle-double-left"></i>
                        <i>Options</i>
                      </template>
                      <b-dropdown-item
                        href="#"
                        :to="{
                          name: 'localcharges_import',
                          params: { id: row.item.id, module: 'fcl' },
                        }"
                      >
                        <span style="color: rgb(86 21 21)">
                          <i class="uil uil-file-check-alt"></i>
                          &nbsp; &nbsp; Import Localcharges
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        href="#"
                        style="color: ##0a399a"
                        @click="downloadFile(row.item.id)"
                      >
                        <span style="color: rgb(1 38 113)"
                          ><i class="uil uil-cloud-download"></i>&nbsp; &nbsp;
                          Download File</span
                        >
                      </b-dropdown-item>
                      <b-dropdown-item
                        href="#"
                        :to="{
                          name: 'goodandfails_localcharge',
                          params: {
                            id: row.item.id,
                            module: 'fcl',
                          },
                        }"
                      >
                        <span style="color: rgb(15, 118, 118)">
                          <i class="uil uil-atm-card"></i>
                          &nbsp; &nbsp; Good & Fail
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        href="#"
                        :to="{
                          name: 'account_detail_localcharge',
                          params: {
                            id: row.item.id,
                          },
                        }"
                      >
                        <span style="color: rgb(17 126 203)">
                          <i class="uil uil-file-check-alt"></i>
                          &nbsp; &nbsp; Details
                        </span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <strong
                    >Filtered {{ totalRows }} of {{ rows }} entries</strong
                  >
                  <div
                    class="dataTables_paginate paging_simple_numbers float-lefts"
                  >
                    <span> </span>
                  </div>
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.badge-soft-warning {
  color: #c39411 !important;
  background-color: rgba(255, 190, 11, 0.2);
}

.badge-soft-success {
  color: #299a70 !important;
  background-color: rgba(67, 211, 158, 0.2);
}

.badge-soft-info {
  color: #259cb5 !important;
  background-color: rgba(37, 194, 227, 0.2);
}

.badge-soft-pdp {
  color: #a243d3 !important;
  background-color: rgb(162 67 211 / 20%);
}

.badge-tier-1 {
  color: #ffffff !important;
  background-color: #1f56d6;
}

.badge-tier-2 {
  color: #ffffff !important;
  background-color: #1f93d6;
}

.badge-tier-3 {
  color: #ffffff !important;
  background-color: #1dbfd7;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}

.parpadea {
  animation-name: parpadeo;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name: parpadeo;
  -webkit-animation-duration: 2s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

@-moz-keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>